import { render, staticRenderFns } from "./ReportHeadingsTotalsList.vue?vue&type=template&id=5e10ba77&"
import script from "./ReportHeadingsTotalsList.vue?vue&type=script&lang=js&"
export * from "./ReportHeadingsTotalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports